<template>
    <section class="content">
        <div class="box box-info" >
          <div class="p-toolbar p-component mb-4">
           <MonthlyTargetDialog ref="targetDialog" @refresh-list="loadTargets"/>
          </div>
          <MonthlySaleTargetList ref="targetList" @refresh-list="loadTargets" @edit-target="handleEdit" @delete-target="handleDelete"/>
       </div>
    </section>
  </template>
  <script>
import MonthlyTargetDialog from '../accountDialog/monthlyTargetDialog.vue'
import MonthlySaleTargetList from './monthlySaleTargetList.vue'
export default {
  name: 'monthlyTarget',
  methods: {
    handleEdit(target) {
      this.$refs.targetDialog.editTarget(target)
    },
    handleDelete(id) {
      this.$refs.targetList.confirmDelete(id)
    },
    async loadTargets() {
      await this.$store.dispatch('loadMonthlyTargetList')
    }
  },
  components: {
    MonthlyTargetDialog,
    MonthlySaleTargetList
  }
}
  </script>



// WEBPACK FOOTER //
// monthlySalesTarget.vue?73d74c08